const StaticsConfig = {
  registryPath: "https://assets.royalbank.com/media",
  appPath: `https://omni.royalbank.com/bbp0/statics/business-onboarding-prequalification-ui`
};

export const environment = {
  interceptEnv: "prod",
  baseUrl: StaticsConfig.appPath,
  production: true,
  staticsConfig: StaticsConfig,
  trustUrl: "https://styles.rbc.com/57106/lucr.js?r=",
  timeoutSeconds: {
    onlinebanking: 1800,
    express: 1200
  },
  links: {
    experiencePath: "ftr-intro/login-portal",
    ftr_intro: {
      base_href: "/ftr-intro/login-portal/index"
    }
  },
  rigAssetCdn: "https://assets.royalbank.com/media",
  riamLoginUrl: "https://business.rbc.com/business-onboarding/home/intro",
  olbLoginUrl: "https://business.rbc.com/mga/sps/authsvc?PolicyId=urn:ibm:security:authentication:asf:bfsonboardingolb&target=",
  ccpaUrl: "https://business.rbc.com/business-onboarding/home/intro",
  creditCardsBaseUrl: "https://www.rbcroyalbank.com"
};
